import styled from 'styled-components';
import { palette } from '../../theme/colors';
import { Link } from 'react-router-dom';
import { toRem } from '../../utils/toRem';

export const SFlexDiv = styled.div`
  flex: 1;
`;

/** Fixed logout only; keep clearance above tab bar and extra space so in-flow content stays clear on short screens. */
export const SSidebarLogoutFooter = styled.div`
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 3.125rem;
  width: 100%;
  max-width: 26rem;
  z-index: 5;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 0 18px;
  box-sizing: border-box;
`;

/** Multi-org banner after last menu row. */
export const SMultiOrgBannerSection = styled.div`
  padding: 1rem 1.125rem;
  flex-shrink: 0;
`;

export const SSidebar = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 19px 0 0;
  /* Reserve space for fixed logout + extra gap so banner/menu never sit flush against the button on small viewports */
  padding-bottom: calc(3.125rem + 4.5rem + 36px);
  height: 100%;
  min-height: 0;
  overflow-y: auto;
`;

export const SRowContainers = styled.div`
  color: ${palette.white};
  padding: 8px 4px 8px 18px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const SContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: ${toRem(24)};
`;

export const SName = styled.div`
  font-size: 16px;
  font-family: 'Roboto-Regular';
  font-weight: 400;
  font-size: 18px;
  line-height: 25px;
  color: ${props => props.theme.palette.text.primary};
  margin-bottom: 7px;
`;

export const SInfoContainer = styled.div`
  display: flex;
`;

export const SInfo = styled(Link)`
  font-size: 12px;
  font-family: 'Roboto-Regular';
  color: ${palette.honeyYellow};
  line-height: 14px;
  text-transform: uppercase;
  text-decoration: none;
`;

export const SElementContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SLanguageBtnRightIconPlaceholder = styled.div`
  display: flex;
  align-items: center;
`;

export const SFlag = styled.img`
  width: 1rem;
  margin-right: 0.5rem;
`;

export const LanguageCheckIcon = styled.img`
  width: ${toRem(14)};
  margin-right: ${toRem(3)};
`;
